import React from 'react';

const Skills = ({ image, alt, competence, centered = false }) => {
    return (
        <div className={`skills ${centered ? 'centered' : ''}`}>
            <div className="content">
                <img className="image" src={image} alt={alt} loading="lazy"/>
                <h3 className="competence">{competence}</h3>
            </div>
        </div>
    );
};

export default Skills;
